var DialogAlertComponent = /** @class */ (function () {
    function DialogAlertComponent() {
    }
    return DialogAlertComponent;
}());
export { DialogAlertComponent };
